module.exports = __webpack_public_path__ + "img/err-img.229551d3.png";